import crawlPolicyData from "../data/crawl-policy-data.json" with { type: "json" };

/** Canonical private/transactional path boundary shared by crawl + attribution. */
export const PRIVATE_CRAWL_PREFIXES: readonly string[] = crawlPolicyData.privateCrawlPrefixes;

export const NON_ACQUISITION_REDIRECT_PREFIXES = [
  "/_",
  "/api",
  "/v1",
  ...PRIVATE_CRAWL_PREFIXES,
] as const;
